import { render, staticRenderFns } from "./Detail-Enquiry.vue?vue&type=template&id=c4fc49ec&scoped=true"
import script from "./Detail-Enquiry.vue?vue&type=script&lang=js"
export * from "./Detail-Enquiry.vue?vue&type=script&lang=js"
import style0 from "./Detail-Enquiry.vue?vue&type=style&index=0&id=c4fc49ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fc49ec",
  null
  
)

export default component.exports